'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decor1Color = require('./decor-1-color.html');

var _decor1Color2 = _interopRequireDefault(_decor1Color);

var _decorAllColors = require('./decor-all-colors.html');

var _decorAllColors2 = _interopRequireDefault(_decorAllColors);

var _stickersAllColors = require('./stickers-all-colors.html');

var _stickersAllColors2 = _interopRequireDefault(_stickersAllColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  "decor-1-color": _decor1Color2.default,
  "decor-all-colors": _decorAllColors2.default,
  "stickers-all-colors": _stickersAllColors2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/templates/decor-decals-stickers/index.js
 **/